// extracted by mini-css-extract-plugin
module.exports = {"drop":"BaseModal_drop__RhUSz","modal":"BaseModal_modal__UzKfM","closeButton":"BaseModal_closeButton__yP6B8"};